import './App.css';
import AutoLogoutListener from './components/AutoLogoutListener';
import { ToastProvider } from './ui/toast/ToastProvider';
import { ConfirmProvider } from './ui/confirm/ConfirmProvider';
import { AuthProvider } from './auth/AuthContext';
import { ErrorBoundary } from './pages/errors';
import { MainAppShell } from './shells/AppShells';
import { LanguageProvider } from './context/LanguageContext';

export default function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <ConfirmProvider>
          <LanguageProvider>
            <AuthProvider>
              <AutoLogoutListener />
              <MainAppShell />
            </AuthProvider>
          </LanguageProvider>
        </ConfirmProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}
